var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _circle2, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTv = function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tv_svg__tv_1_",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 319.8 193",
    style: {
      enableBackground: "new 0 0 319.8 193"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".tv_svg__st0{opacity:.3;fill:#231f20;enable-background:new}.tv_svg__st1{fill:#313131}.tv_svg__st2,.tv_svg__st3{stroke-miterlimit:10}.tv_svg__st2{fill:#fff;stroke:#231f20}.tv_svg__st3{fill:#aaa}.tv_svg__st3,.tv_svg__st5,.tv_svg__st8{stroke:#231f20}.tv_svg__st5{fill:#e2e2e2;stroke-miterlimit:10}.tv_svg__st8{fill:#537029;stroke-width:.5}.tv_svg__st10,.tv_svg__st8,.tv_svg__st9{stroke-miterlimit:10}.tv_svg__st9{fill:#a5e051;stroke:#231f20;stroke-width:.5}.tv_svg__st10{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round}.tv_svg__st10,.tv_svg__st13{stroke-width:.5}.tv_svg__st13,.tv_svg__st15{fill:none;stroke:#231f20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("g", {
    id: "tv_svg__tv-full"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tv_svg__four"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st0",
    d: "M29.3 186.5c-35.7 1.5-5.9 2.2 5.4 2.2 11.8 0 17.1-.4 34.5-.3 0-2.7-2.3-2-10.6-2.3s-22.8.2-29.3.4zM259.7 184.7c-35.7 1.5-5.9 2.2 5.4 2.2 11.8 0 17.1 0 34.5.1 16 0 6.1-1.8-11-2.1-8.4-.1-22.4-.5-28.9-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st1",
    d: "M225.5 128.7c-2.8-36.5 13.3-61.7 40.3-63.8 27.1-2.1 46.5 20.3 49.3 57 2.8 36.5-13 61.7-40.1 63.8-27 2-46.8-20.6-49.5-57zm67.8-5.2c-2-26.1-11.7-40.6-26.1-39.5-14.6 1.1-22 16.9-20 43 2 26.3 11.7 40.6 26.3 39.5 14.4-1.1 21.8-16.8 19.8-43zM60.4 94.4c-4.7-.6-8.8-.5-12.8 0l7.2-25.6 46.1 5.8 5.9-21.6L40 44.6 29.7 82.4c0 .1-.1.2-.1.3l-12.2 44.9c4.5-4.8 15.7-14.5 31.9-13.2 21.4 1.6 27.6 16 26.6 27-1.1 11-7.3 22.7-23.9 24.2-15.9 1.4-29.1-12.6-30.3-23L3.9 157.3c7.5 16.3 22 26.7 40.6 29.1 28.3 3.6 51.4-13.6 54.9-41.1 3.2-26.1-13.1-47.6-39-50.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "tv_svg__tv"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st0",
    d: "M110.9 5.4s-2.6-.1-2.5 5.2 0 23.4 0 23.4-.1 4.8 4.6 5c4.8.2 11.4.7 12.7-3.8-.4-2-1.4-28.3-1.4-28.3l-13.4-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st2",
    d: "M117.9 4.6h-4.4s-3.5-.2-3.5 5.2v22.4s-.2 4.8 5.3 4.8h5.5s6.2.2 6.2-5.5V9s0-4.2-4-4.3c-4.1-.1-5.1-.1-5.1-.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st2",
    d: "M118.5 8.4s-4.6-.6-4.7 4 4.8 4.5 4.8 4.5 4.5.5 4.7-4.1c.1-4.7-4.8-4.4-4.8-4.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st2",
    d: "M121.1 13.8s11.1-2.3 10.9 20.5 0 45.8 0 45.8-1.5 15.3 14.5 15.3c-.3-1.7 0-2.1 0-2.1s-13.2.1-12.7-13.2 0-45.5 0-45.5 1.7-22.8-12.7-23c-1.5.1-1.5 2.3 0 2.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st3",
    d: "M197.7 48.6 182.4 84h4.1l12.3-35.1zM159 61.5l15.9 24.9 2.1-1.9-17.1-23.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.2 89.1s2-7.2 12.6-7.1 13.8 8.8 13.8 8.8-12.6-2.2-26.4-1.7z",
    style: {
      fill: "#f3f3f3",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st3",
    d: "M110.6 109.1s.5-7.2 21.5-8.1 65.5-.8 70.9-.4 10.5 1.5 12.4 11.4c.7-5.5.1-15.1-10.6-15.2s-76.5 1.5-76.5 1.5-17.1.8-17.7 10.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st0",
    d: "M151.7 186.4s-39.4.4-45.9 1-5.9 2.8 5.4 3.1 81.9-.9 103.7.1c15.1.7 8.6-3.3.2-3.6s-55.3-.8-63.4-.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st5",
    d: "M224.3 110.7s1-18.3-14.2-20.4c0 0-43.7-5.9-89.6 1.8-14.1 2.4-21 5.7-20.9 35.5.1 29.8 1.5 40 1.5 40s.1 20.4 14.1 20.5c14 .1 85.1.5 96.8.2 11.7-.3 14.1-13.4 14-26.5-.2-13.1-1.7-51.1-1.7-51.1zm-17 58.6c-7.7.2-78.6 0-87.8-.1-9.2-.1-9.3-9.6-9.3-9.6s-1-21.5-1.1-41.2c0-13.8 6.9-18 16.3-18.7 31-2.5 80.6-1 80.6-1 10 1.3 9.4 13.4 9.4 13.4s1 35 1 43.7c.2 8.6-1.4 13.3-9.1 13.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.8 173.6s-.7.3-1.3 2.5c-.8 2.7 2.1 4.4 4.3 3.8 2.2-.6 3.1-2.2 2.4-4.3-.5-1.9-2.4-3.3-5.4-2z",
    style: {
      fill: "#3c71aa",
      stroke: "#231f20",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.1 173.2s-1.6.8-1.4 2.7c.2 1.9 2.1 3.1 4 2.6s2.8-1.8 2.5-3.5c-.2-1.6-2.4-2.9-5.1-1.8z",
    style: {
      fill: "#5096e2",
      stroke: "#231f20",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st8",
    d: "M194.6 174.7s-.4.2-.9 1.7c-.5 1.8 1.5 3 3 2.6 1.5-.4 2.1-1.5 1.6-2.9-.3-1.4-1.6-2.3-3.7-1.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st9",
    d: "M194.9 174.4s-1.1.5-1 1.9c.1 1.3 1.4 2.1 2.7 1.8 1.3-.4 1.9-1.2 1.7-2.4-.1-1.2-1.6-2.1-3.4-1.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st8",
    d: "M186.2 174.8s-.4.2-.9 1.7c-.5 1.8 1.5 3 3 2.6 1.5-.4 2.1-1.5 1.6-2.9-.4-1.3-1.7-2.3-3.7-1.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st9",
    d: "M186.4 174.5s-1.1.5-1 1.9c.1 1.3 1.4 2.1 2.7 1.8 1.3-.4 1.9-1.2 1.7-2.4-.1-1.2-1.6-2.1-3.4-1.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st8",
    d: "M177.4 174.8s-.4.2-.9 1.7c-.5 1.8 1.5 3 3 2.6 1.5-.4 2.1-1.5 1.6-2.9-.4-1.3-1.6-2.3-3.7-1.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st9",
    d: "M177.6 174.5s-1.1.5-1 1.9c.1 1.3 1.4 2.1 2.7 1.8 1.3-.4 1.9-1.2 1.7-2.4-.1-1.2-1.6-2.1-3.4-1.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st10",
    d: "m206.9 174.1.1 1.4M205.9 175s-.4.4-.2.9c.3 1 1.7.8 1.7.8s1.5-.2.7-1.7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 177.5s2.2 6.6 10.8 6.7 98 0 98 0 11.7.4 13.2-9.3",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st0",
    d: "M104 180.6s4 3.4 7.6 3.7c3.6.4 67.7 0 67.7 0h33.3s7.6-.5 11-5.3c-1 2.3-2.5 9.3-14.4 9.4-11.9.1-94.6-.3-94.6-.3s-7.2 0-10.6-7.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.8 172.9h7.2s1.9 0 1.9 2.7c0 3.7-.9 3.8-3.3 3.7-2.4-.1-5.6-.1-5.6-.1s-1.8 0-1.8-2.4c0-2.1-.3-3.9 1.6-3.9z",
    style: {
      fill: "#e2d133",
      stroke: "#231f20",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st13",
    d: "M115.5 175.1h5.8M115.5 176.2h4.9M115.5 177.4h5.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "tv_svg__st5",
    cx: 159.4,
    cy: 60.7,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "tv_svg__st5",
    cx: 198.2,
    cy: 49.1,
    r: 2.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st0",
    d: "M178.6 82.6s-4 1.9-1.6 3.8 7.8 1.8 7.8 1.8h-14.9s3-5.3 8.7-5.6zM105.1 99.1s-4.9 5.6-3.5 44.2c1.2 34.2 4.3 34.9 7.3 37.2 4.7 3.7 20.2 2.7 54.9 3.7-7.1 0-35.5.3-50.6-.1-10.4 0-11.2-9.3-11.4-10.6-.2-1-6.5-65.5 3.3-74.4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.6 22.4s-4.6-.3-4.8 4.4 4.8 4.5 4.8 4.5 4.5.5 4.7-4.1c.2-4.8-4.7-4.8-4.7-4.8z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st15",
    d: "M117.5 26.7v.6M119.8 26.7v.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.5 8.4s-2.2.6-2.2 4.1c0 2.5.9 3.7 1.7 4.2",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "tv_svg__st0",
    d: "M113.4 11.2s-.9 3.7.4 6.2 5.2 1.6 6 1.1 3.3-2.6 3.4-3.2c-1.1.7-2.5 2-4.3 1.7-1.8-.3-3.4 0-3.5-5.4 0-1.1 1.2-3 1.2-3s-2.5.5-3.2 2.6zM117.3 22.7s4-1 5 3.7c.7 3.5-1.4 4.5-1.4 4.5s3-.8 2.4-4.9c-.7-4.3-5.4-3.5-6-3.3z"
  })))));
};
export default SvgTv;